// Decorative hero artwork for the public landing pages. Same visual language as the About hero
// (dark slate, emerald/sky glow, dotted route with checkpoints) so the pages read as one family.
import homeHero from './home-hero.svg'
import organizersHero from './organizers-hero.svg'
import participantsHero from './participants-hero.svg'

export const HERO_IMAGES = {
  home: { src: homeHero, width: 1920, height: 1080 },
  organizers: { src: organizersHero, width: 1920, height: 1080 },
  participants: { src: participantsHero, width: 1920, height: 1080 },
} as const
